import { render, staticRenderFns } from "./pf-description-column.vue?vue&type=template&id=630d4e88"
import script from "./pf-description-column.vue?vue&type=script&lang=js"
export * from "./pf-description-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports